import Vue from 'vue';
import { Padder } from '@qoala/ui';
export default Vue.extend({
    name: 'AuthenticatedLayout',
    components: {
        Padder
    }
});
